import { render, staticRenderFns } from "./CardInventory.vue?vue&type=template&id=547bdec8"
import script from "./CardInventory.vue?vue&type=script&lang=js"
export * from "./CardInventory.vue?vue&type=script&lang=js"
import style0 from "./CardInventory.vue?vue&type=style&index=0&id=547bdec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports